module.exports = __webpack_public_path__ + "img/ic_package.7383eba8.svg";